'use client';

import React from 'react';

const FloatingWNSTNWidget = React.lazy(() =>
  import('@benzinga/ads/wnstn-floating').then(module => ({ default: module.FloatingWNSTNWidget })),
);

interface DeferredFloatingWNSTNWidgetProps {
  articleID?: number;
  disabled?: boolean;
  questions?: string[] | null;
}

export const DeferredFloatingWNSTNWidget: React.FC<DeferredFloatingWNSTNWidgetProps> = ({
  articleID,
  disabled = false,
  questions,
}) => {
  const [shouldLoad, setShouldLoad] = React.useState(false);

  React.useEffect(() => {
    if (disabled || shouldLoad) return;

    const load = () => setShouldLoad(true);
    const interactionEvents: Array<keyof WindowEventMap> = ['keydown', 'pointerdown', 'scroll', 'touchstart'];

    interactionEvents.forEach(eventName => window.addEventListener(eventName, load, { once: true, passive: true }));

    return () => {
      interactionEvents.forEach(eventName => window.removeEventListener(eventName, load));
    };
  }, [disabled, shouldLoad]);

  if (disabled || !shouldLoad) return null;

  return (
    <React.Suspense fallback={null}>
      <FloatingWNSTNWidget articleID={articleID} questions={questions} />
    </React.Suspense>
  );
};
